import React from "react";
import ReactTooltip from 'react-tooltip';
import { Link } from "react-router-dom";

const ManageButtonGroup = ({ exhibitID, deleteExhibit }) => {
  const editURL = `/manage/${exhibitID}`;
  const artifactURL = `/artifacts/${exhibitID}`;

  return (
    <div style={{ paddingTop: 10 }}>
      <ReactTooltip />
      <div className="btn-group">
        <Link
          to={editURL}
          className="btn btn-info btn-sm"
          data-tip="Edit Exhibit Details"
        >
          <i className="fa fa-edit" />
        </Link>
        <Link
          to={artifactURL}
          className="btn btn-info btn-sm"
          data-tip="Manage Artifacts"
        >
          <i className="fa fa-upload" />
        </Link>
        <a
          className="btn btn-danger btn-sm"
          href="/"
          data-tip="Delete Exhibit"
          onClick={e => {
            e.preventDefault();
            deleteExhibit(exhibitID);
          }}
        >
          <i className="fa fa-trash" />
        </a>
      </div>
    </div>
  );
};

export default ManageButtonGroup;



// WEBPACK FOOTER //
// ./src/pages/Exhibits/ManageButtonGroup.jsx